import React, { useState } from "react";
import { Form, Button, Card, Container, Row, Col, Spinner } from "react-bootstrap";
import { UsuarioManager } from "managers";
import { useAuthentication } from "hooks";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";

export default function CambioPasswordObligatorio() {
  const { usuario, logout, refrescarSesion } = useAuthentication();
  const { Message, Warning } = useMessage();
  const { handleException } = useExceptionHandler();

  const [form, setForm] = useState({
    passwordActual: "",
    nuevoPassword: "",
    passwordConfirm: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!form.passwordActual || !form.nuevoPassword || !form.passwordConfirm) {
      Warning({ message: "Todos los campos son requeridos." });
      return;
    }
    if (form.nuevoPassword !== form.passwordConfirm) {
      Warning({ message: "La nueva contraseña y su confirmación no coinciden." });
      return;
    }

    setLoading(true);
    UsuarioManager.cambiarContrasenia({
      ...usuario,
      passwordActual: form.passwordActual,
      nuevoPassword: form.nuevoPassword,
      passwordConfirm: form.passwordConfirm,
    })
      .then(() => {
        Message({ message: "Contraseña actualizada correctamente." });
        // Refresca la sesión: debeCambiarPassword pasa a false y App muestra el dashboard.
        return refrescarSesion();
      })
      .catch((err) => handleException(err))
      .finally(() => setLoading(false));
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f4f5f7" }}
    >
      <Row className="justify-content-center w-100">
        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="shadow-sm">
            <Card.Body className="p-4">
              <h4 className="mb-2">Cambio de contraseña requerido</h4>
              <p className="text-muted">
                Su contraseña ha expirado. Para continuar debe establecer una nueva contraseña.
              </p>

              <Form onSubmit={onSubmit} autoComplete="off">
                <Form.Group>
                  <Form.Label>Contraseña Actual</Form.Label>
                  <Form.Control
                    name="passwordActual"
                    type="password"
                    autoComplete="current-password"
                    value={form.passwordActual}
                    onChange={onChange}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Nueva Contraseña</Form.Label>
                  <Form.Control
                    name="nuevoPassword"
                    type="password"
                    autoComplete="new-password"
                    value={form.nuevoPassword}
                    onChange={onChange}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>Confirmar Contraseña</Form.Label>
                  <Form.Control
                    name="passwordConfirm"
                    type="password"
                    autoComplete="new-password"
                    value={form.passwordConfirm}
                    onChange={onChange}
                  />
                </Form.Group>

                <div className="d-flex justify-content-between align-items-center mt-4">
                  <Button variant="link" className="px-0" onClick={() => logout()} disabled={loading}>
                    Cerrar sesión
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Cambiar contraseña"
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
